<ul>
  @for (item of menuItems; track item) {
    <li>
      <a [routerLink]="[item.url]" routerLinkActive="active">
        {{item.name}}
      </a>
    </li>
  }
</ul>
